<template>
  <v-container fluid class="down-top-padding">
    <BaseBreadcrumb :title="page.title" :icon="page.icon" :breadcrumbs="breadcrumbs"></BaseBreadcrumb>
    <v-row>
      <v-col cols="12" sm="12">
        <BaseCard>
          <MatrizLista
            idTipoCapex="4"
            tipoCapex="camp"
            nombreTipoCapex="Campo"
            vAuthAcl="gh-pres-capex-campo"
            v-auth-acl="'gh-pres-capex-campo'"
          ></MatrizLista>
        </BaseCard>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: 'CapexCampo',
  components: {
    MatrizLista: () => import('../../components/MatrizLista')
  },
  data: () => ({
    page: {
      title: 'CAPEX Campo'
    },
    breadcrumbs: [
      {
        text: 'Presupuesto',
        disabled: true
      },
      {
        text: 'CAPEX Campo',
        disabled: false
      }
    ]
  }),
  methods: {
    open() {},
    close() {}
  }
};
</script>
